import React, { useState, useEffect } from 'react';
import Header from '../components/Header.jsx';
import Footer from '../components/Footer.jsx';
import { feedbackAPI } from '../services/api';
import api from '../services/api';
import profilePic from '../Images/Rashi-Jyotish-profilepic.jpg';
import panditji from '../Images/Panditji.jpg';
import praapyarpanLogo from '../Images/PRAAPYARPAN-Logo.png';
import upiImage from '../Images/Praapyarpan UPI Id.jpg';
import praapyarpan1 from '../Images/Praapyarpan gallery/1.jpg';
import praapyarpan2 from '../Images/Praapyarpan gallery/2.jpg';
import praapyarpan3 from '../Images/Praapyarpan gallery/3.jpg';
import praapyarpan4 from '../Images/Praapyarpan gallery/4.jpg';
import praapyarpan5 from '../Images/Praapyarpan gallery/5.jpg';
import praapyarpan6 from '../Images/Praapyarpan gallery/6.jpg';
import whatsappLogo from '../Images/whatsapp logo.png';
import { useAuth } from '../context/AuthContext';

const Dashboard = () => {
  const { user } = useAuth();
  const [reviews, setReviews] = useState([]);
  const [currentSet, setCurrentSet] = useState(0);
  const [galleryImages, setGalleryImages] = useState([]);
  const [lightboxImage, setLightboxImage] = useState(null);
  const [galleryLightbox, setGalleryLightbox] = useState({ open: false, src: '', type: '' });
  const [selectedService, setSelectedService] = useState(null);
  const [formData, setFormData] = useState({
    rating: 5,
    review_text: ''
  });

  const reviewsPerSet = 3;

  useEffect(() => {
    loadFeedback();
  }, []);

  useEffect(() => {
    if (reviews.length > 0) {
      const interval = setInterval(() => {
        setCurrentSet((prev) => (prev + 1) % Math.ceil(reviews.length / reviewsPerSet));
      }, 5000);
      return () => clearInterval(interval);
    }
  }, [reviews]);

  const loadFeedback = async () => {
    try {
      const response = await feedbackAPI.getApproved();
      setReviews(response.data.feedback || []);
    } catch (error) {
      console.error('Error loading feedback:', error);
    }
  };

  const handleSubmitFeedback = async (e) => {
    e.preventDefault();
    if (!user) {
      alert('Please sign in to submit feedback');
      return;
    }

    try {
      await feedbackAPI.submit(formData);
      alert('Thank you for your feedback! It will be reviewed and published soon.');
      setFormData({ rating: 5, review_text: '' });
    } catch (error) {
      alert('Error submitting feedback. Please try again.');
    }
  };

  const getReviewsForSet = (setIndex) => {
    const start = setIndex * reviewsPerSet;
    return reviews.slice(start, start + reviewsPerSet);
  };
const tiles = [
  { 
    src: "https://plus.unsplash.com/premium_photo-1679941208786-6d089e1c6515?ixlib=rb-4.1.0&auto=format&fit=crop&q=80&w=1200", 
    label: "Zodiac Insights",
    description: "Easy guidance based on your zodiac sign. Understand your basic personality, strengths, and how your day or week may go according to astrology."
  },
  { 
    src: "https://www.gurucool.life/_next/image?url=https%3A%2F%2Fdrive.gurucool.life%2FblogsImage%2FWhatsApp%20Image%202023-10-31%20at%205.14.48%20PM.jpeg&w=1080&q=75", 
    label: "Kundli Analysis",
    description: "A Kundli is your birth chart made using your birth date, time, and place. It shows how planets affect your career, relationships, health, and important life events."
  },
  { 
    src: "https://images.unsplash.com/photo-1627764574958-fb54cd7d7448?ixlib=rb-4.1.0&auto=format&fit=crop&q=80&w=1200", 
    label: "Tarot Prediction",
    description: "Tarot cards give intuitive guidance about your present situation and future possibilities. Helpful for decision-making and getting clarity on specific questions."
  },
  { 
    src: "https://images.unsplash.com/photo-1643319125503-f9d079d64b9a?ixlib=rb-4.1.0&auto=format&fit=crop&q=80&w=1200", 
    label: "Gemstone Therapy",
    description: "Wearing the right gemstone can bring positive energy and reduce obstacles. We recommend stones based on your Kundli to improve balance and well-being."
  },
  { 
    src: "https://images.unsplash.com/photo-1600585154340-be6161a56a0c?q=80&w=1200&auto=format&fit=crop", 
    label: "Vastu Guidance",
    description: "Vastu helps you arrange your home or office in a way that brings positivity, peace, and prosperity. Simple tips to improve energy flow in your space."
  },
  { 
    src: "https://resize.indiatvnews.com/en/resize/newbucket/1200_-/2019/08/numerology-mulank-1566264513-1566266234.jpg", 
    label: "Numerology Reading",
    description: "Numerology uses your name and birth date to reveal your important numbers. These numbers explain your personality, strengths, challenges, and lucky patterns."
  }
];


  const praapyarpanImages = [praapyarpan1, praapyarpan2, praapyarpan3, praapyarpan4, praapyarpan5, praapyarpan6];

  useEffect(() => {
    // Fetch gallery images from API
    const fetchGallery = async () => {
      try {
        const response = await api.get('/gallery/public');
        setGalleryImages(response.data.gallery || []);
      } catch (error) {
        console.error('Error fetching gallery:', error);
      }
    };
    fetchGallery();
  }, []);

  const openWhatsApp = () => {
    const message = encodeURIComponent('Hello! I would like to inquire about your astrology services.');
    window.open(`https://wa.me/918879424647?text=${message}`, '_blank');
  };

  return (
    <div style={{
      background: 'linear-gradient(120deg, #7bb2f5ff 0%, #ffed88ff 35%, #f9b6a4 70%, #ff7277de 100%)',
      minHeight: '100vh'
    }}>
      <Header />
      <main>
        {/* HERO SECTION */}
        <section id="home" className="hero">
          <div>
            <div className="kicker">Trusted Astrologer by our Clients</div>
            <h1>Unlock Your Cosmic Destiny</h1>
            <p>Personalized Vedic readings, remedies, and guidance — blending classical Jyotish with practical advice for modern life.</p>

            <div className="image-grid" style={{ marginTop: '22px' }}>
              {tiles.map((tile, index) => (
                <div key={index} className="tile" onClick={() => setSelectedService(tile)}>
                  <img src={tile.src} alt={tile.label} />
                  <div className="label">{tile.label}</div>
                </div>
              ))}
            </div>
          </div>

          <aside className="hero-aside card">
            <img src={profilePic} alt="Kinnari Dubey" />
            <h3>Kinnari Dubey</h3>
            <p>With over a decade of dedicated Vedic astrology practice, I offer accurate, compassionate, and practical guidance designed to bring clarity and balance to your life. My approach includes personalized remedies and insights tailored to your unique circumstances. Backed by formal education, professional certifications, and multiple awards and recognitions in the field, I combine deep traditional knowledge with modern understanding to deliver meaningful results.</p>
            <div style={{ display: 'flex', gap: '8px', marginTop: '12px' }}>
              <button className="book" onClick={openWhatsApp}>Request Session</button>
              <button className="ghost" onClick={() => document.getElementById('gallery').scrollIntoView({ behavior: 'smooth' })}>View Gallery</button>
            </div>
          </aside>
        </section>

        {/* ABOUT & SERVICES */}
        <section className="section">
          <div className="card" style={{ padding: '22px', borderRadius: '16px', marginBottom: '18px' }}>
            <h2 style={{ margin: '0 0 12px', fontFamily: "'Playfair Display',serif", color: 'var(--maroon)' }}>
              About Shree Rashi Jyotish
            </h2>
            <p style={{ color: 'var(--muted)', margin: 0 }}>
              We combine classical Vedic astrology with modern insights to provide clear, practical, and compassionate readings. Services include birth chart analysis, compatibility, remedies, muhurat selection, and gemstone consultation.
            </p>
          </div>

          <div className="grid-3">
            <div className="card">
              <h3>Services</h3>
              <ul style={{ color: 'var(--muted)', paddingLeft: '18px', margin: '8px 0 0' }}>
                <li>Birth Chart Analysis</li>
                <li>Compatibility & Matchmaking</li>
                <li>Career & Finance Guidance</li>
                <li>Gemstone Consultation</li>
                <li>Muhurat & Timing</li>
                <li>Remedies & Rituals</li>
              </ul>
            </div>
            <div className="card">
              <h3>Languages</h3>
              <p style={{ color: 'var(--muted)', margin: '6px 0' }}>Hindi • English • Gujarati • All Indian Languages</p>
              <h3 style={{ marginTop: '12px' }}>Hours</h3>
              <p style={{ color: 'var(--muted)', margin: '6px 0' }}>Mon - Sun: 4:00 PM - 9:00 PM</p>
            </div>
            <div className="card">
              <h3>Location</h3>
              <p style={{ color: 'var(--muted)', margin: '6px 0' }}>
                Netaji Subhash Chandra Rd, Siddharth Nagar, Mulund West, Mumbai, Maharashtra, 400080
              </p>
              <p style={{ color: 'var(--muted)', margin: '6px 0' }}>
                <strong>Phone:</strong> +91 8879424647
              </p>
            </div>
            <div className="card">
              <h3>Find Us Here</h3>
              <iframe
                src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d1215.6595316775074!2d72.9527535!3d19.1767674!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3be7b8fbc6ca367d%3A0xd2cd331296d5ace4!2sRashi%20Jyotish!5e1!3m2!1sen!2sin!4v1763580631495!5m2!1sen!2sin"
                width="350"
                height="300"
                style={{ border: 0 }}
                allowFullScreen
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                title="Rashi Jyotish Google Map"
              ></iframe>
            </div>
          </div>
        </section>

        {/* BOOK PANDITJI */}
        <section className="section">
          <div className="card" style={{ padding: '32px', borderRadius: '16px', background: 'linear-gradient(135deg, rgba(122, 19, 113, 0.14), rgba(236, 45, 227, 0.2))' }}>
            <h2 style={{ margin: '0 0 24px', fontFamily: "'Playfair Display',serif", color: 'var(--maroon)', textAlign: 'center', fontSize: '28px' }}>
              Book Panditji for Your Special Event
            </h2>

            <div className="panditji-grid">
              {/* Left: Image Card */}
              <div className="panditji-image-card">
                <img src={panditji} alt="Pandit Ji" style={{ width: '100%', height: '280px', objectFit: 'cover', borderRadius: '10px', marginBottom: '16px', cursor: 'pointer' }} onClick={() => setLightboxImage(panditji)} />
                <h3 style={{ margin: '0 0 8px', color: 'var(--maroon)', fontSize: '20px' }}>Pandit Sushil Sastri</h3>
                <h5 style={{ margin: '0 0 8px', color: 'var(--maroon)', fontSize: '16px' }}>(Baglamukhi Upasak)</h5>
                <p style={{ margin: '0 0 16px', color: 'var(--muted)', fontSize: '14px' }}>Certified Vedic Priest • 25+ Years Experience</p>

                <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
                  <a href="https://drive.google.com/file/d/1ZyJPPUwbbrMwId2ngpLHh_1tq3NR9Km-/view?usp=sharing" target="_blank" rel="noopener noreferrer" style={{ padding: '12px 16px', borderRadius: '10px', background: 'linear-gradient(135deg, var(--maroon), #a01642)', color: '#fff', fontWeight: 700, textDecoration: 'none', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '8px' }}>
                    📄 View Brochure
                  </a>
                  <button onClick={() => { const msg = encodeURIComponent('I would like to inquire about Pooja/Panditji.'); window.open(`https://wa.me/918804406633?text=${msg}`, '_blank'); }} style={{ padding: '12px 16px', borderRadius: '10px', background: '#25D366', color: '#fff', fontWeight: 700, border: 'none', cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '8px' }}>
                    <img src={whatsappLogo} alt="WhatsApp" style={{ width: '20px', height: '20px' }} />
                    WhatsApp Now
                  </button>
                  <a href="tel:+918804406633" style={{ padding: '12px 16px', borderRadius: '10px', background: 'var(--maroon)', color: '#fff', fontWeight: 700, textDecoration: 'none', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '8px' }}>
                    📞 Call +91 88044 06633
                  </a>
                </div>
              </div>

              {/* Right: Services List */}
              <div>
                <h3 style={{ margin: '0 0 16px', color: 'var(--maroon)', fontSize: '22px' }}>Professional Vedic Services for All Occasions</h3>
                <p style={{ color: 'var(--muted)', margin: '0 0 20px', lineHeight: '1.7' }}>Book our experienced Pandit Ji for authentic Vedic rituals and ceremonies. With deep knowledge of traditional practices and modern sensibilities, we ensure your special moments are blessed with proper rituals performed with devotion and precision.</p>

                <div style={{ background: '#fff', padding: '20px', borderRadius: '12px', border: '1px solid rgba(122,19,43,0.1)', marginBottom: '20px' }}>
                  <h4 style={{ margin: '0 0 14px', color: 'var(--maroon)', fontSize: '18px' }}>Services We Provide:</h4>
                  <div className="panditji-services-grid">
                    {['Griha Pravesh (Housewarming)', 'Satyanarayan Katha', 'Wedding Ceremonies', 'Naamkaran (Baby Naming)', 'Ganesh Puja', 'Lakshmi Puja', 'Rudrabhishek', 'Thread Ceremony (Upanayana)', 'Shradh & Pind Daan', 'Corporate Puja Events', 'Das MahaVidhya Anusthan', 'Baglamukhi Anusthan', 'Online Pooja', 'Vaastu Consultation'].map((service, idx) => (
                      <div key={idx} style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                        <span style={{ color: 'var(--yellow)', fontSize: '18px' }}>✓</span>
                        <span style={{ color: '#374151', fontSize: '15px' }}>{service}</span>
                      </div>
                    ))}
                  </div>
                </div>

                <div style={{ background: 'rgba(255,193,7,0.1)', borderLeft: '4px solid var(--yellow)', padding: '16px', borderRadius: '8px' }}>
                  <p style={{ margin: 0, color: '#856404', fontSize: '14px', lineHeight: '1.6' }}>
                    <strong>📅 Available for booking:</strong> Flexible scheduling for your convenience. All puja materials can be arranged. Home visits available across Mumbai and surrounding areas.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* SERVICES GRID */}
        <section className="section">
          <h2 style={{ textAlign: 'center', marginBottom: '14px', color: 'var(--maroon)' }}>Our Services</h2>
          <div className="services">
            <div className="service">
              <div className="icon">🪄</div>
              <h4>Birth Chart Analysis</h4>
              <p style={{ color: 'var(--muted)' }}>Detailed Vedic chart reading and dasha analysis.</p>
            </div>
            <div className="service">
              <div className="icon">💞</div>
              <h4>Compatibility</h4>
              <p style={{ color: 'var(--muted)' }}>Kundali matching and relationship guidance.</p>
            </div>
            <div className="service">
              <div className="icon">🎯</div>
              <h4>Career Guidance</h4>
              <p style={{ color: 'var(--muted)' }}>Clarity on professional choices & timing.</p>
            </div>
            <div className="service">
              <div className="icon">🃏</div>
              <h4>Tarot Reading</h4>
              <p style={{ color: 'var(--muted)' }}>Insightful card readings for life guidance.</p>
            </div>
            <div className="service">
              <div className="icon">👼</div>
              <h4>Angel Board</h4>
              <p style={{ color: 'var(--muted)' }}>Connect with divine messages and guidance.</p>
            </div>
            <div className="service">
              <div className="icon">🏠</div>
              <h4>Vastu Consultancy</h4>
              <p style={{ color: 'var(--muted)' }}>Harmonize your space with ancient wisdom.</p>
            </div>
          </div>
        </section>

        {/* REVIEWS */}
        <section id="clients" className="section">
          <h2 style={{ textAlign: 'center', marginBottom: '14px', color: 'var(--maroon)' }}>What Clients Say</h2>
          {reviews.length > 0 && (
            <>
              <div className="reviews">
                {getReviewsForSet(currentSet).map((review, index) => (
                  <div key={review.feedback_id} className="review active" style={{ left: `${index * 33.333}%` }}>
                    <div className="review-header">
                      {review.profile_picture && (review.profile_picture.startsWith('http') || review.profile_picture.startsWith('data:image')) ? (
                        <img 
                          src={review.profile_picture} 
                          alt={review.full_name} 
                          className="client-photo"
                          style={{ objectFit: 'cover' }}
                          onError={(e) => { e.target.style.display = 'none'; e.target.nextSibling.style.display = 'flex'; }}
                        />
                      ) : (
                        <div 
                          className="client-photo" 
                          style={{ 
                            background: 'var(--maroon)', 
                            color: '#fff', 
                            display: 'flex', 
                            alignItems: 'center', 
                            justifyContent: 'center',
                            fontSize: '24px',
                            fontWeight: '700'
                          }}
                        >
                          {review.full_name?.charAt(0)?.toUpperCase()}
                        </div>
                      )}
                      <div className="stars">{'★'.repeat(review.rating)}</div>
                    </div>
                    <p style={{ color: 'var(--muted)', fontStyle: 'italic' }}>"{review.feedback_text}"</p>
                    <p style={{ marginTop: '12px' }}>
                      <strong>{review.full_name}</strong><br />
                      <small style={{ color: 'var(--muted)' }}>Verified Client</small>
                    </p>
                  </div>
                ))}
              </div>
              <div className="review-nav">
                {[...Array(Math.ceil(reviews.length / reviewsPerSet))].map((_, index) => (
                  <div key={index} className={`review-dot ${index === currentSet ? 'active' : ''}`} onClick={() => setCurrentSet(index)}></div>
                ))}
              </div>
            </>
          )}

          {/* Feedback Form */}
          {user ? (
            <div className="card" style={{ marginTop: '30px', maxWidth: '600px', margin: '30px auto 0' }}>
              <h3 style={{ color: 'var(--maroon)', marginBottom: '16px' }}>Share Your Experience</h3>
              <form onSubmit={handleSubmitFeedback}>
                <label>Rating</label>
                <select value={formData.rating} onChange={(e) => setFormData({ ...formData, rating: parseInt(e.target.value) })} required>
                  <option value="5">★★★★★ (5 stars)</option>
                  <option value="4">★★★★☆ (4 stars)</option>
                  <option value="3">★★★☆☆ (3 stars)</option>
                  <option value="2">★★☆☆☆ (2 stars)</option>
                  <option value="1">★☆☆☆☆ (1 star)</option>
                </select>
                <label>Your Review</label>
                <textarea rows="4" value={formData.review_text} onChange={(e) => setFormData({ ...formData, review_text: e.target.value })} placeholder="Share your experience..." required></textarea>
                <button type="submit">Submit Feedback</button>
              </form>
            </div>
          ) : (
            <div className="card" style={{ marginTop: '30px', maxWidth: '600px', margin: '30px auto 0', textAlign: 'center', padding: '40px' }}>
              <h3 style={{ color: 'var(--maroon)', marginBottom: '12px' }}>Share Your Experience</h3>
              <p style={{ color: 'var(--muted)', marginBottom: '20px', lineHeight: '1.6' }}>
                Please sign in to your account to submit a review. Your feedback helps us serve you better!
              </p>
              <button 
                onClick={() => window.location.href = '/login'} 
                style={{
                  padding: '12px 24px',
                  background: 'linear-gradient(90deg, var(--yellow), #ffb84d)',
                  color: '#3b0b12',
                  border: 'none',
                  borderRadius: '10px',
                  fontWeight: 700,
                  cursor: 'pointer',
                  boxShadow: '0 8px 24px rgba(255,185,59,0.12)'
                }}
              >
                Sign In to Submit Review
              </button>
            </div>
          )}
        </section>

        {/* GALLERY */}
        <section id="gallery" className="section">
          <h2 style={{ textAlign: 'center', marginBottom: '14px', color: 'var(--maroon)' }}>Gallery</h2>
          <div className="gallery card" style={{ padding: '12px', display: 'grid', gridTemplateColumns: 'repeat(4,1fr)', gap: '10px' }}>
            {galleryImages.length === 0 ? (
              <div style={{ gridColumn: '1 / -1', textAlign: 'center', padding: '40px', color: 'var(--muted)' }}>
                No gallery images available yet
              </div>
            ) : (
              galleryImages.map((img, index) => (
                <img 
                  key={img.gallery_id} 
                  src={img.image_url} 
                  alt={img.title || `Gallery ${index + 1}`} 
                  onClick={() => setGalleryLightbox({ open: true, src: img.image_url, type: 'jyotish' })} 
                  style={{ cursor: 'pointer', objectFit: 'cover', width: '100%', height: '200px', borderRadius: '8px' }}
                />
              ))
            )}
          </div>
        </section>

        {/* PRAAPYARPAN FOUNDATION */}
        <section className="section" style={{ marginTop: '40px' }}>
          <div className="card" style={{ background: 'linear-gradient(135deg, rgba(139, 0, 0, 0.21), rgba(178, 34, 34, 0.16))', border: '2px solid rgba(139,0,0,0.15)', padding: '32px', borderRadius: '16px' }}>
            <div style={{ textAlign: 'center', marginBottom: '20px' }}>
              <img src={praapyarpanLogo} alt="PRAAPYARPAN" style={{ maxWidth: '150px' }} />
            </div>
            <h2 style={{ margin: '0 0 16px', fontFamily: "'Playfair Display',serif", color: '#8B0000', fontSize: '32px', fontWeight: 800, textAlign: 'center', letterSpacing: '1px' }}>
              PRAAPYARPAN FOUNDATION
            </h2>
            <p style={{ color: 'var(--muted)', textAlign: 'center', maxWidth: '800px', margin: '0 auto 24px', fontSize: '16px', lineHeight: '1.6' }}>
              Join us in making a difference. PRAAPYARPAN Foundation is dedicated to serving humanity through compassion, care, and community support. We believe in creating positive change and empowering lives through our various initiatives. Together, we can build a better tomorrow for those in need.
            </p>

            {/* PRAAPYARPAN Gallery */}
            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3,1fr)', gap: '12px', margin: '24px 0', maxWidth: '900px', marginLeft: 'auto', marginRight: 'auto' }}>
              {praapyarpanImages.map((img, index) => (
                <img key={index} src={img} alt={`PRAAPYARPAN ${index + 1}`} onClick={() => setGalleryLightbox({ open: true, src: img, type: 'praapyarpan' })} style={{ width: '100%', height: '140px', objectFit: 'cover', borderRadius: '10px', cursor: 'pointer', transition: 'transform 0.3s, box-shadow 0.3s' }} onMouseOver={(e) => { e.target.style.transform = 'scale(1.05)'; e.target.style.boxShadow = '0 8px 20px rgba(139,0,0,0.3)'; }} onMouseOut={(e) => { e.target.style.transform = 'scale(1)'; e.target.style.boxShadow = 'none'; }} />
              ))}
            </div>

            <div style={{ textAlign: 'center', marginTop: '28px', display: 'flex', gap: '16px', justifyContent: 'center', flexWrap: 'wrap' }}>
              <a 
                href="/praapyarpan-donation.html" 
                target="_blank"
                rel="noopener noreferrer"
                style={{ 
                  padding: '14px 28px', 
                  background: 'linear-gradient(135deg, #8B0000, #DC143C)', 
                  color: '#fff', 
                  border: 'none', 
                  borderRadius: '12px', 
                  fontSize: '16px', 
                  fontWeight: 800, 
                  cursor: 'pointer', 
                  boxShadow: '0 8px 24px rgba(139,0,0,0.2)', 
                  transition: 'transform 0.2s',
                  textDecoration: 'none',
                  display: 'inline-block'
                }} 
                onMouseOver={(e) => e.target.style.transform = 'scale(1.05)'} 
                onMouseOut={(e) => e.target.style.transform = 'scale(1)'}
              >
                💝 Add Donation
              </a>
              
              <a 
                href="/Praapyarpan-form.html" 
                target="_blank"
                rel="noopener noreferrer"
                style={{ 
                  padding: '14px 28px', 
                  background: 'linear-gradient(135deg, #0d5a0d, #28a745)', 
                  color: '#fff', 
                  border: 'none', 
                  borderRadius: '12px', 
                  fontSize: '16px', 
                  fontWeight: 800, 
                  cursor: 'pointer', 
                  boxShadow: '0 8px 24px rgba(40,167,69,0.2)', 
                  transition: 'transform 0.2s',
                  textDecoration: 'none',
                  display: 'inline-block'
                }} 
                onMouseOver={(e) => e.target.style.transform = 'scale(1.05)'} 
                onMouseOut={(e) => e.target.style.transform = 'scale(1)'}
              >
                🤝 Become a Member
              </a>
              
              <a 
                href="https://praapyarpan.org" 
                target="_blank"
                rel="noopener noreferrer"
                style={{ 
                  padding: '14px 28px', 
                  background: 'linear-gradient(135deg, #0d5a0d, #28a745)', 
                  color: '#fff', 
                  border: 'none', 
                  borderRadius: '12px', 
                  fontSize: '16px', 
                  fontWeight: 800, 
                  cursor: 'pointer', 
                  boxShadow: '0 8px 24px rgba(40,167,69,0.2)', 
                  transition: 'transform 0.2s',
                  textDecoration: 'none',
                  display: 'inline-block'
                }} 
                onMouseOver={(e) => e.target.style.transform = 'scale(1.05)'} 
                onMouseOut={(e) => e.target.style.transform = 'scale(1)'}
              >
                🌐 Visit Our Website
              </a>

              <button 
                onClick={() => setGalleryLightbox({ open: true, src: upiImage, type: 'praapyarpan' })} 
                style={{ 
                  padding: '14px 28px', 
                  background: 'linear-gradient(135deg, #b8860b, #daa520)', 
                  color: '#fff', 
                  border: 'none', 
                  borderRadius: '12px', 
                  fontSize: '16px', 
                  fontWeight: 800, 
                  cursor: 'pointer', 
                  boxShadow: '0 8px 24px rgba(184,134,11,0.2)', 
                  transition: 'transform 0.2s' 
                }} 
                onMouseOver={(e) => e.target.style.transform = 'scale(1.05)'} 
                onMouseOut={(e) => e.target.style.transform = 'scale(1)'}
              >
                💳 View UPI Details
              </button>
            </div>
          </div>
        </section>

        <Footer />
      </main>

      {/* Lightbox */}
      {lightboxImage && (
        <div className="lightbox" onClick={() => setLightboxImage(null)}>
          <img src={lightboxImage} alt="Lightbox" style={{ maxWidth: '92%', maxHeight: '86%', borderRadius: '12px' }} />
        </div>
      )}

      {/* Gallery Lightbox */}
      {galleryLightbox.open && (
        <div className="gallery-lightbox-overlay active" onClick={() => setGalleryLightbox({ open: false, src: '', type: '' })}>
          <div className="gallery-lightbox-container" onClick={(e) => e.stopPropagation()} style={{ background: galleryLightbox.type === 'jyotish' ? 'linear-gradient(135deg, rgba(122,19,43,0.05), rgba(255,193,7,0.08))' : 'linear-gradient(135deg, rgba(139,0,0,0.05), rgba(178,34,34,0.08))' }}>
            <button className="gallery-lightbox-close" onClick={() => setGalleryLightbox({ open: false, src: '', type: '' })}>×</button>
            <img src={galleryLightbox.src} alt="Gallery" />
          </div>
        </div>
      )}

      {/* Service Description Modal */}
      {selectedService && (
        <div className="lightbox" onClick={() => setSelectedService(null)}>
          <div 
            className="card" 
            onClick={(e) => e.stopPropagation()} 
            style={{ 
              maxWidth: '600px', 
              padding: '32px', 
              position: 'relative',
              background: 'linear-gradient(135deg, rgba(255,255,255,0.98), rgba(255,253,250,0.98))',
              boxShadow: '0 20px 60px rgba(122,19,43,0.2)',
              borderRadius: '16px'
            }}
          >
            <button 
              onClick={() => setSelectedService(null)} 
              style={{ 
                position: 'absolute', 
                top: '16px', 
                right: '16px', 
                background: 'transparent', 
                border: 'none', 
                fontSize: '32px', 
                cursor: 'pointer',
                color: 'var(--maroon)',
                lineHeight: '1'
              }}
            >
              ×
            </button>
            <h2 style={{ 
              fontFamily: "'Playfair Display',serif", 
              color: 'var(--maroon)', 
              marginBottom: '20px',
              fontSize: '28px'
            }}>
              {selectedService.label}
            </h2>
            <p style={{ 
              color: 'var(--muted)', 
              lineHeight: '1.8',
              fontSize: '16px',
              marginBottom: '24px'
            }}>
              {selectedService.description}
            </p>
            <button 
              onClick={openWhatsApp}
              style={{ 
                padding: '12px 24px', 
                background: 'linear-gradient(90deg, var(--yellow), #ffb84d)', 
                color: '#3b0b12', 
                border: 'none', 
                borderRadius: '10px', 
                fontWeight: 700, 
                cursor: 'pointer',
                width: '100%',
                fontSize: '16px',
                boxShadow: '0 8px 24px rgba(255,185,59,0.12)'
              }}
            >
              Book This Service
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default Dashboard; 